import { z } from "zod";

export const ComputerFileEntrySchema = z.object({
  path: z.string(),
  kind: z.enum(["file", "dir"]),
  size: z.number(),
});
export type ComputerFileEntry = z.infer<typeof ComputerFileEntrySchema>;

/** Display paths are relative to the bot's authorized workspace, never the host root. */
export function computerFileName(path: string): string {
  return path.replace(/\/$/, "").split("/").at(-1) || "/";
}

export function computerParentPath(path: string): string {
  const parts = path.split("/").filter(Boolean);
  parts.pop();
  return `${path.startsWith("/") ? "/" : ""}${parts.join("/")}`;
}

/** A capture of the owned browser, ready for the existing artifact store. */
export const ComputerBrowserPageSchema = z.object({
  url: z.string(),
  title: z.string(),
  loading: z.boolean(),
  capture: z.object({ name: z.string(), contentBase64: z.string() }),
});
export type ComputerBrowserPage = z.infer<typeof ComputerBrowserPageSchema>;
